<template>
  <div class="container">
    <headerNav />
    <el-row :gutter="20">
      <router-view />
    </el-row>
  </div>
</template>

<script>
import headerNav from "@/components/com/headerNav.vue";
import "@/style/venue.scss";
export default {
  components: {
    headerNav
  },
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/com/layout.vue